import { LoadingButton } from '@mui/lab'
import { Stack } from '@mui/material'
import { Fragment } from 'react'
import { AuthFormHeader } from '../FormHeader'

import { OtpInput } from 'ui-components/components/atoms/OtpInput'

interface SignUpEmailPasswordConfirmFormProps {
  email?: string
  slots?: {
    Form?: React.ElementType
    Header?: React.ElementType
    OtpInput?: React.ElementType
    Button?: React.ElementType
  }
  slotProps?: {
    Form?: any
    Header?: any
    OtpInput?: any
    Button?: any
  }
}

export function SignUpEmailPasswordConfirmForm(
  props: SignUpEmailPasswordConfirmFormProps
) {
  const { email, slots, slotProps } = props

  const Slots = {
    Form: Fragment,
    Header: AuthFormHeader,
    OtpInput: OtpInput,
    Button: LoadingButton,
    ...slots
  }

  return (
    <>
      <Slots.Header
        title='Confirm your email'
        subtitle={`We sent a code to ${
          email || 'your email'
        }. Enter the code to start using your account.`}
        {...slotProps?.Header}
      />

      <Stack
        direction='column'
        spacing={3}
        component={Slots.Form}
        {...slotProps?.Form}
      >
        <Slots.OtpInput
          maxLength={6}
          {...slotProps?.OtpInput}
        />

        <Slots.Button
          color='primary'
          variant='contained'
          type='submit'
          size='large'
          sx={{
            borderRadius: 99
          }}
          {...slotProps?.Button}
        >
          Continue
        </Slots.Button>
      </Stack>
    </>
  )
}
